import React from "react";
import ReactDOM from "react-dom/client";
import "./index.less";
import App from "./App";
import "@arco-design/web-react/dist/css/arco.css";
import reportWebVitals from "./reportWebVitals";
import "./public-path";
import { proxyConfig } from '@/config/proxyConfig'
const AID = process.env.REACT_APP_AID
if (AID !== '0') {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = proxyConfig[process.env.REACT_APP_PLATFORM].favIcon;
  document.head.appendChild(link);

  // 创建并添加 title
  const title = document.createElement('title');
  title.textContent = proxyConfig[process.env.REACT_APP_PLATFORM].FavTitle;
  document.head.appendChild(title);
  // const roots = ReactDOM.createRoot(
  //   document.getElementById("root") as HTMLElement
  // );
  // roots.render(<App />);
}
let root = null;
function render (props) {
    const { container } = props;
    root = root || ReactDOM.createRoot(container ? container.querySelector("#root") : document.getElementById("root") );
    root.render(
      <App />
    );
}

if (!window.__POWERED_BY_QIANKUN__) {
    render({});
}

export async function bootstrap () {
    console.log("[react18] react app bootstraped");
}

export async function mount (props) {
    console.log("[react18] props from main framework", props);
    render(props);
}

export async function unmount (props) {
    root.unmount();
    root = null;
}

reportWebVitals();